export default __webpack_public_path__ + "static/logo-ki-c368855d38cf17a65d56b3ba58289bb7.svg";